import React from 'react';
import ReactDOM from 'react-dom';
import ErrorBoundary from "../../../../core/error-boundary";
import NavigationMenu_PersonalViews from "./my-views/my-views";
import NavigationMenu_TopHeader from "../../components/top-header/top-header";
import {NavigationSectionType} from "../../../../core/model2/navigation/@const";
import NavigationSection from "../../../../core/model2/navigation/navigation-section";
import MainMenu_HomeCustomViews from "./custom-views/custom-views";
import {MenuComponentProps} from "../const";
import VScroll from "../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll";
import MainMenu_Pins from "../../components/pins/pins";
import {SpaceHome} from "../../../../core/model2/space/system/home";
import MenuTopHeader_SearchActive from "../../components/top-header/search/search";
import {MenuSpaceSearch} from "../../components/search/menu-space-search";
import MenuSearch_Results from "../../../search/search-results/menu-search-results";
import MenuTopHeader_SearchButton from "../../components/top-header/search/search-button";
import NavigationMenu_HomeLocalSettings from "./local-settings"

type State = {
    loaded  : boolean
    reRender: boolean
}

export default class MainMenu_Home extends React.Component<MenuComponentProps,State> {

    private animationDelay  : any
    private animShow        : boolean = false
    private spaceHome       : SpaceHome

    public localSettings    : NavigationMenu_HomeLocalSettings
    public spaceSearch      : MenuSpaceSearch


    public navigationSection : NavigationSection    = gd.navigationStructure.get(NavigationSectionType.HOME)

    constructor(props:MenuComponentProps) {
        super(props)

        this.localSettings = new NavigationMenu_HomeLocalSettings()

        this.spaceHome      = new SpaceHome()
        this.spaceSearch    = new MenuSpaceSearch(this.spaceHome, this.reRender)

        this.state = {
            loaded  : !!gd.session.myWork,
            reRender: true
        }
    }

    componentDidMount() {
        this.animationDelay = _.delay(()=>{
            this.animShow = true
            const dom = ReactDOM.findDOMNode(this)
            gd.utils.Dom.addClass(dom, 'anim-show')
        }, 50);

        this._loadMyWork();
    }

    componentWillUnmount() {
        clearTimeout(this.animationDelay)
    }

    _loadMyWork = () => {
        if (!this.state.loaded) {
            gd.session.updateSessionCollections(['myWork']).done(()=>{
                this.setState({
                    loaded: true
                })
            })
        }
    }

    reRender = ()=> {
        this.setState({
            reRender: true
        });
    }

    render() {

        // console.green("render")
        const classes = Classes('main-menu-container menu-home ui5-menu',{
            'animation': gd.layout.shouldAnimateMenu && !this.props.noAnimation,
            'anim-show': this.animShow
        })

        //menu-scroll
        return (
            <div className={classes}>

                {!this.spaceSearch.isActive &&
                    <NavigationMenu_TopHeader space = {gd.spaces.home}>

                        <MenuTopHeader_SearchButton className="m-r-15" spaceSearch={this.spaceSearch} />

                    </NavigationMenu_TopHeader>
                }

                {this.spaceSearch.isActive &&
                    <div className="top-header flex-row-between-center">
                        <MenuTopHeader_SearchActive spaceSearch={this.spaceSearch}/>
                    </div>
                }

                <VScroll ref={this.props.refScroll} className="main-menu-scroll" mutationObserverEnabled={true}>

                    {this.spaceSearch.enabled && <MenuSearch_Results space          = {gd.spaces.home}
                                                                     searchResult   = {this.spaceSearch.searchResults}/>}

                    {!this.spaceSearch.enabled &&
                        <>
                            {this.state.loaded &&
                                <NavigationMenu_PersonalViews navigationSection = {this.navigationSection}
                                                              localSettings     = {this.localSettings} />
                            }

                            <ErrorBoundary>
                                <MainMenu_Pins space={this.spaceHome} />

                                <MainMenu_HomeCustomViews navigationSection={this.navigationSection} />

                                {/*<PinnedProjects navigationSection={this.navigationSection} />*/}
                                {/*<MainMenu_PinnedItems navigationSection={this.navigationSection} />*/}
                            </ErrorBoundary>
                        </>
                    }
                </VScroll>
            </div>
        );
    }
}
